import { supabase } from './supabase';
import { err, ok, type Result } from './result';

export interface AuthUser {
  id: string;
  email?: string | null;
  user_metadata?: Record<string, any> | null;
}

export const getCurrentUserId = async (): Promise<Result<string | null>> => {
  try {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error) throw error;
    return ok(user?.id ?? null);
  } catch (error) {
    return err(error);
  }
};

export const getCurrentUser = async (): Promise<Result<AuthUser | null>> => {
  try {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error) throw error;
    if (!user) return ok(null);
    return ok({ id: user.id, email: user.email, user_metadata: user.user_metadata });
  } catch (error) {
    return err(error);
  }
};

export const updateUserMetadata = async (data: Record<string, unknown>): Promise<Result<null>> => {
  try {
    const { error } = await supabase.auth.updateUser({ data });
    if (error) throw error;
    return ok(null);
  } catch (error) {
    return err(error);
  }
};

export const signOut = async (): Promise<Result<null>> => {
  try {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
    return ok(null);
  } catch (error) {
    return err(error);
  }
};

export const subscribeToAuthChanges = (
  callback: (event: string, session: unknown) => void,
): { unsubscribe: () => void } => {
  const { data } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
  return {
    unsubscribe: () => data?.subscription.unsubscribe(),
  };
};
